import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import moment from "moment";

//Logo
import LogoSistema from "../../../assets/img/img/logo.png";

//Components
import Loading from "../../../components/Loading";

//Services
import { showMessage } from "../../../services/message";
import { api_GET } from "../../../services/api_service";

export default function RelatorioADC({ history }) {

    const [dadosRelatorio, setDadosRelatorio] = useState([]);
    const [loading, setLoading] = useState(false);

    const queryString = require('query-string');

    const getMonthName = (mes) => {
        if (!mes) return "";
        const date = new Date();
        date.setMonth(mes - 1);
        return date.toLocaleString('pt-BR', { month: 'long' });
    }

    const q_mes = queryString.parse(window.location.search).mes;
    const q_ano = queryString.parse(window.location.search).ano;
    const mesExtenso = getMonthName(q_mes);
    const mesExtensoCap = mesExtenso.charAt(0).toUpperCase() + mesExtenso.slice(1);


    async function loadDadosRelatorio() {
        try {
            const query_string = queryString.parse(window.location.search);

            const mes = query_string.mes;
            const ano = query_string.ano;
            const hash_usuario = query_string.hash_usuario;
            const hash_contratada = query_string.hash_contratada;
            const tenantId = query_string.tenantId;
            const percentualIPT = query_string.percentualIPT;
            const pontosIPT = query_string.pontosIPT;

            setLoading(true);
            const { data } = await api_GET(`RelatorioADC?mes=${mes}&ano=${ano}&hash_contratada=${hash_contratada}&hash_usuario=${hash_usuario}&percentualIPT=${percentualIPT}&pontosIPT=${pontosIPT}`, `${tenantId}`);
            setDadosRelatorio(data);
        } catch (error) {
            showMessage("Aviso", error.message, 'error', null);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadDadosRelatorio();
    }, []);

    return (
        <div className="bg-white" style={{ height: '100vh' }}>
            {loading && <Loading />}
            <div className="container-fluid " style={{ background: "#FFF", height: "100%" }}>
                <div className="d-flex justify-content-between align-items-center p-3">
                    <img src={LogoSistema} alt="logo do sistema" height={50} />
                    <button
                        className="btn btn-info"
                        id="btnImprimir"
                        onClick={() => {
                            if (!loading) window.print();
                        }}
                    >
                        {loading && <Spinner size="sm" color="primary" />} &nbsp; Imprimir &nbsp;
                    </button>
                </div>

                <div className="text-center">
                    <h1>Relatório de ADC</h1>
                </div>

                {!loading &&
                    <>
                        <div className="text-center my-4">
                            <h2>ADC - {dadosRelatorio?.contratada ?? ""} - {mesExtensoCap} {q_ano}</h2>
                        </div>

                        <div className="d-flex justify-content-center w-100 my-4">
                            <div className="col-md-8">
                                <table className="table table-bordered text-center" style={{ border: '2px solid black' }}>
                                    <thead>
                                        <tr>
                                            <th className="text-center" style={{ border: '1px solid black', fontWeight: 'bold' }}>Indice</th>
                                            <th className="text-center" style={{ border: '1px solid black', fontWeight: 'bold' }}>Percentual</th>
                                            <th className="text-center" style={{ border: '1px solid black', fontWeight: 'bold' }}>Pontos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* IRD */}
                                        <tr>
                                            <td className="text-center" style={{ border: '1px solid black' }}>IRD</td>
                                            <td className="text-center" style={{ border: '1px solid black' }}>{(dadosRelatorio?.percentualIRD ?? 0).toFixed(2)}%</td>
                                            <td className="text-center" style={{ border: '1px solid black' }}>{dadosRelatorio?.irD_Pts ?? 0}</td>
                                        </tr>
                                        {/* IA */}
                                        <tr>
                                            <td className="text-center" style={{ border: '1px solid black' }}>IA</td>
                                            <td className="text-center" style={{ border: '1px solid black' }}>{(dadosRelatorio?.percentualIA ?? 0).toFixed(2)}%</td>
                                            <td className="text-center" style={{ border: '1px solid black' }}>{dadosRelatorio?.iA_Pts ?? 0}</td>
                                        </tr>
                                        {/* IF */}
                                        <tr>
                                            <td className="text-center" style={{ border: '1px solid black' }}>IF</td>
                                            <td className="text-center" style={{ border: '1px solid black' }}>{(dadosRelatorio?.percentualIF ?? 0).toFixed(2)}%</td>
                                            <td className="text-center" style={{ border: '1px solid black' }}>{dadosRelatorio?.iF_Pts ?? 0}</td>
                                        </tr>
                                        {/* IPT */}
                                        <tr>
                                            <td className="text-center" style={{ border: '1px solid black' }}>IPT</td>
                                            <td className="text-center" style={{ border: '1px solid black' }}>{(dadosRelatorio?.percentualIPT ?? 0).toFixed(2)}%</td>
                                            <td className="text-center" style={{ border: '1px solid black' }}>{dadosRelatorio?.ipT_Pts ?? 0}</td>
                                        </tr>

                                        {/* TOTAL ADC */}
                                        <tr>
                                            <td colSpan="2" className="text-start ps-3" style={{ border: '1px solid black', fontWeight: 'bold' }}>
                                                ADC de {mesExtensoCap} {q_ano} - {dadosRelatorio?.contratada ?? ""}
                                            </td>
                                            <td className="text-center" style={{ border: '1px solid black', fontWeight: 'bold' }}>{dadosRelatorio?.adC_Pontos ?? 0}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    );
}
